import { useEffect, useState } from 'react';

import Form from 'components/Form';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

import { AccessTime } from '@mui/icons-material';
import { MobileTimePicker } from '@mui/x-date-pickers';

import MuiTextField from 'components/Form/MuiTextField';

import RowContainer from '../../components/RowContainer';
import RowContent from '../../components/RowContentBord';
import SectionTitle from '../../components/SectionTitle';

import RowContentDialysis from './components/RowContent';

interface Props extends IFormRegister, IFormValues, IFormWatch {
  disabled?: boolean;
}

const DialysisInfo = (props: Props) => {
  const { disabled, register, getValues, setValue, watch } = props;

  const [bloodVessel, setBloodVessel] = useState(getValues('vascular_access'));

  useEffect(() => {
    if (isNaN(Number(getValues('visiting_route')))) {
      setValue('visiting_route_etc', getValues('visiting_route'));
      setValue('visiting_route', '0');
    }
    if (isNaN(Number(getValues('vascular_access')))) {
      setValue('vascular_access_etc', getValues('vascular_access'));
      setValue('vascular_access', '0');
    }
  }, []);

  const contents = [
    {
      label: 'Ngày thực hiện',
      element: (
        <Form.MuiTextField
          required={false}
          type="date"
          disabled={disabled}
          {...register('date')}
          sx={{ marginRight: '10px' }}
        />
      ),
    },
    {
      label: 'Thời gian\nthực hiện',
      element: (
        <MobileTimePicker
          disabled={disabled}
          value={watch('time') || null}
          onChange={v => setValue('time', v)}
          renderInput={params => (
            <MuiTextField
              {...params}
              required={false}
              placeholder="00:00"
              InputProps={{ endAdornment: <AccessTime /> }}
            />
          )}
        />
      ),
    },
    {
      label: 'Thiết bị chạy thận',
      element: (
        <Form.MuiTextField
          {...register('dialyzer')}
          required={false}
          disabled={disabled}
        />
      ),
    },
    {
      label: 'Máy chạy thận',
      element: (
        <Form.MuiTextField
          {...register('dialysis_machine')}
          required={false}
          disabled={disabled}
        />
      ),
    },
    {
      label: 'Phương pháp chạy thận',
      element: (
        <RowContainer xs={12}>
          <RowContentDialysis
            title={'Phương pháp\nchạy thận'}
            titleRatio={1}
            childrenRatio={11}
          >
            <Form.MuiTextField
              {...register('dialysate')}
              required={false}
              disabled={disabled}
            />
          </RowContentDialysis>
        </RowContainer>
      ),
    },
    {
      label: 'Lộ trình\nthăm khám',
      element: (
        <RowContainer xs={12}>
          <RowContentDialysis
            title={'Lộ trình\nthăm khám'}
            titleRatio={1}
            childrenRatio={11}
          >
            <Form.MuiRadioGroup
              disabled={disabled}
              i18nKey="DIALYSIS.DIALYSIS_INFO.ROUTE"
              values={[1, 2, 3, 0]}
              defaultValue={getValues('visiting_route')}
              onChange={v => {
                setValue('visiting_route', v);
                if (v !== 0) setValue('visiting_route_etc', '');
              }}
              width="140px"
            />
            <Form.MuiTextField
              {...register('visiting_route_etc')}
              placeholder="Nhập"
              fullWidth={false}
              required={false}
              disabled={disabled}
            />
          </RowContentDialysis>
        </RowContainer>
      ),
    },
    {
      label: 'Loại mạch máu',
      element: (
        <>
          <RowContainer xs={12}>
            <RowContent
              title={'Loại mạch máu'}
              titleRatio={1}
              childrenRatio={11}
            >
              <Form.MuiRadioGroup
                disabled={disabled}
                i18nKey="DIALYSIS.DIALYSIS_INFO.BLOOD_VESSEL"
                values={[1, 2, 3, 4, 5, 6, 0]}
                defaultValue={bloodVessel}
                value={bloodVessel}
                onChange={v => {
                  setValue('vascular_access', v);
                  setBloodVessel(v);
                  setValue('vascular_access_etc', '');
                }}
                width="140px"
              />
              <Form.MuiTextField
                {...register('vascular_access_etc')}
                placeholder="Nhập"
                fullWidth={false}
                required={false}
                disabled={disabled}
              />
            </RowContent>
          </RowContainer>
        </>
      ),
    },
    {
      label: 'Y tá tiếp nhận',
      element: (
        <>
          <RowContainer xs={12}>
            <RowContent
              title={'Y tá tiếp nhận'}
              titleRatio={1}
              childrenRatio={5}
            >
              <Form.MuiTextField
                {...register('starting_nurse')}
                required={false}
                disabled={disabled}
              />
            </RowContent>
            <RowContentDialysis
              title={'Y tá phụ\nphụ trách'}
              titleRatio={1}
              childrenRatio={5}
            >
              <Form.MuiTextField
                {...register('ending_nurse')}
                required={false}
                disabled={disabled}
              />
            </RowContentDialysis>
          </RowContainer>
        </>
      ),
    },
  ];
  return (
    <>
      <SectionTitle title="Thông tin chạy thận" />
      <RowContainer xs={12}>
        {contents.map(({ label, element }) => {
          if (
            label === 'Loại mạch máu' ||
            label === 'Y tá tiếp nhận' ||
            label === 'Phương pháp chạy thận' ||
            label === 'Lộ trình\nthăm khám'
          ) {
            return <>{element}</>;
          }

          return (
            <>
              <RowContentDialysis
                key={label}
                title={label}
                titleRatio={1}
                childrenRatio={5}
              >
                {element}
              </RowContentDialysis>
            </>
          );
        })}
      </RowContainer>
    </>
  );
};

export default DialysisInfo;
